<template>
  <div>
    <headerComponent />

    <div class="shoppingCart">
      <div class="w1300">
        <div class="tle">
          <h2 class="tit-36 fw700 cor-000">我的购物车</h2>
        </div>
        <div class="box">
          <table class="table">
            <thead>
              <tr class="tit-14">
                <th>
                  <!-- <input
                    type="checkbox"
                    v-model="isAllSelected"
                    @change="toggleAllSelection"
                  /> -->

                  <el-checkbox
                    v-model="isAllSelected"
                    @change="toggleAllSelection"
                    label="全选"
                  >
                  </el-checkbox>
                </th>
                <th>商品</th>
                <th>价格</th>
                <th>数量</th>
                <th>小计</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in cartItems" :key="index">
                <td class="check">
                  <el-checkbox
                    v-model="item.checked"
                    @change="updateTotalPrice"
                  >
                  </el-checkbox>
                </td>
                <td class="proInfo">
                  <div class="flex-c">
                    <el-image
                      :src="item.tu"
                      alt="item.name"
                      class="product-img"
                    ></el-image>

                    <div class="info">
                      <div class="name fw700">{{ item.ming }}</div>
                      <div class="guigeming tit-14 mt-10">
                        {{ item.guigeming }}
                      </div>
                      <div class="num mt-10">x{{ item.shuliang }}</div>
                    </div>
                  </div>
                </td>
                <td class="price tit-20">¥{{ item.jiage }}</td>
                <td class="quantity">
                  <el-input-number
                    size="small"
                    v-model="item.shuliang"
                    @change="(value) => handleChange(value, item)"
                    :min="1"
                    :max="100"
                  ></el-input-number>
                </td>
                <td class="subtotal tit-20">
                  ¥{{ item.shuliang * item.jiage }}
                </td>
                <td class="remove">
                  <button @click="removeItem(item)" class="tit-20 cur">
                    <i class="el-icon-close"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="total-price tit-24">
            商品总金额: ¥{{ totalPrice }}
            <span class="tit-18">包邮（偏远地区除外）</span>
          </div>
          <div class="action-buttons">
            <button class="btn1" @click="continueShopping">继续购物</button>
            <button class="btn2" @click="checkout">去结算</button>
          </div>
        </div>
      </div>
    </div>

    <footerComponent />
  </div>
</template>

<script>
// 引用头部组件
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer.vue";
export default {
  name: "ShoppingCartIndex",

  components: {
    headerComponent,
    footerComponent,
  },

  data() {
    return {
      cartItems: [
        // {
        // 	id: 1,
        // 	name: "轮式双臂人形机器人",
        // 	price: "88000.00",
        // 	quantity: 1,
        // 	checked: true,
        // 	image: require("@/assets/navTwo-img.png"), // 替换为实际图片地址
        // },
        // {
        // 	id: 2,
        // 	name: "自适应智能夹爪",
        // 	price: "2222.00",
        // 	quantity: 1,
        // 	checked: false,
        // 	image: require("@/assets/navTwo-img.png"),
        // },
        // {
        // 	id: 3,
        // 	name: "关节模组",
        // 	price: "2222.00",
        // 	quantity: 1000,
        // 	checked: false,
        // 	image: require("@/assets/navTwo-img.png"),
        // },
      ],
      // isAllSelected: false,
      totalPrice: 0,
      shu: [],
    };
  },

  computed: {
    // 全选状态
    isAllSelected: {
      get() {
        return this.cartItems.every((item) => item.checked);
      },
      set(value) {
        this.cartItems.forEach((item) => (item.checked = value));
      },
    },
  },

  created() {
    this.CSH(); //数据初始化
  },

  methods: {
    // 接口数据
    CSH() {
      var that = this;

      // 检查登录状态 - 修复键名匹配问题
      const userInfo = this.$qu("yonghux") || {};

      if (!userInfo["kouling"]) {
        this.$alert("请先登录才能查看购物车", "", {
          confirmButtonText: "登录",
          confirmButtonClass: "Loginanniu",
          distinguishCancelAndClose: true,
          center: true,
          roundButton: true,
          callback: (action) => {
            if (action == "confirm") {
              this.$dakai("/login");
            }
          },
        });
        return; // 添加return防止未登录时继续执行
      }
      that.$post("m=limitao&k=gouwuche", function(s) {
        // that.$xiaoxi(s.shu);
        // that.cartItems = s.shu.lie;
        // uni.$emit('GWC')
        if (s && s.shu && s.shu.lie) {
          that.cartItems = s.shu.lie;
          that.updateTotalPrice(); // 初始化后更新总价
        } else {
          that.cartItems = []; // 确保数据为空时清空列表
        }
      });
    },
    // 全选
    toggleAllSelection() {
      this.updateTotalPrice();
    },

    handleChange(value, item) {
      this.ids = "";
      this.updateTotalPrice();

      // 调用后端接口更新购物车商品数量
      this.$post(
        "m=limitao&k=gouwuche&c=Jiajian",
        {
          id: item.id,
          kucun: value,
        },
        (s) => {
          if (s && s.shu) {
            this.$message({
              type: "success",
              message: "数量更新成功!",
            });
          }
        },
      );
    },
    // 删除
    removeItem(e) {
      this.$confirm("此操作将删除该商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$post("m=limitao&k=gouwuche&c=shanchu", { ids: e.id }, (s) => {
          this.updateTotalPrice();
          this.CSH();
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
      });

      //   this.cartItems.splice(index, 1);
      //   this.updateTotalPrice();
    },
    // 更新总价
    updateTotalPrice(e) {
      this.ids = "";
      this.totalPrice = this.cartItems
        .filter((item) => item.checked)
        .reduce((sum, item) => {
          // 当item被选中时，将其id拼接到this.ids
          if (item.checked) {
            this.ids += "_" + item.id;
          }
          // 继续计算总价
          return sum + item.shuliang * item.jiage;
        }, 0);
      // .reduce((sum, item) => sum + item.shuliang * item.jiage, 0);
    },

    continueShopping() {
      // 这里可以添加跳转到其他页面继续购物的逻辑，比如 router.push('/products')
      this.$router.push("/");
      console.log("继续购物");
    },
    checkout() {
      var that = this;
      // console.log(that.ids,'that.ids');
      // 这里可以添加去结算页面的逻辑，比如 router.push('/checkout')
      // console.log("去结算");
      if (that.ids) {
        that.$router.push({ name: "orderConfirm", params: { id: that.ids } });
      } else {
        that.$xiaoxi("请勾选商品");
      }
    },
  },
};
</script>

<style scoped lang="less">
// 隐藏导航栏购物车
/deep/ .header .headBox .header-right .car {
  opacity: 0;
  visibility: hidden;
}

.shoppingCart {
  padding: 0.6rem 0;

  .box {
    margin-top: 0.6rem;
  }
}

.table {
  width: 100%;
  border-collapse: collapse;

  thead {
    border-bottom: 1px solid #000000;

    th {
      padding-bottom: 0.2rem;
      text-align: center;
      color: #626262;

      &:first-child {
        text-align: left;
      }
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid #e0e0e0;

      td {
        padding: 0.2rem 0.3rem;
        text-align: center;

        &:first-child {
          padding-left: 0;
          text-align: left;
        }
      }

      .check {
        width: 5%;
      }

      .proInfo {
        width: 30%;

        .product-img {
          width: 1rem;
          height: 1rem;

          /deep/ img {
            object-fit: contain;
          }
        }

        .info {
          margin-left: 0.5rem;
          text-align: left;

          .num {
            color: #9f9f9f;
          }
        }
      }

      .price {
        width: 10%;
      }

      .quantity {
        width: 10%;

        /deep/ .el-input-number {
          width: 100px;

          .el-input__inner {
            padding: 0 30px;
          }

          span {
            background: none;

            i {
              color: #333;
              font-weight: 700;
            }
          }

          input {
            color: #333;
            font-weight: 700;
          }

          .el-input-number__decrease,
          .el-input-number__increase {
            border-right: 0;
            border-left: 0;
          }
        }
      }

      .subtotal {
        width: 15%;
      }

      .remove {
        width: 5%;
      }
    }
  }
}

.total-price {
  margin-top: 0.6rem;
  text-align: right;

  span {
    color: #a3a3a3;
    margin-left: 0.3rem;
  }
}

.action-buttons {
  text-align: right;
  margin-top: 0.5rem;

  button {
    min-width: 1.52rem;
    padding: 0.14rem 0.45rem;
    border-radius: 100px;
    cursor: pointer;

    &.btn1 {
      background: #f1f1f1;
      color: #333;
    }

    &.btn2 {
      background: linear-gradient(-14deg, #001ff5 0%, #41b9e0 100%);
      color: #fff;
      margin-left: 0.24rem;
    }

    &:hover {
      opacity: 0.8;
    }
  }
}

@media screen and (max-width: 767px) {
  .shoppingCart {
    .table {
      thead {
        tr {
          th {
            opacity: 0;
            &:first-child {
              opacity: 1;
            }
          }
        }
      }

      tbody tr {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        width: 125%;
        > td {
          width: auto;

          &.subtotal {
            display: flex;
            align-items: center;
          }

          &.remove {
            padding: 0.1rem;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
    }
  }
}
</style>
